// This file centralizes ALL data for the HireDjango page
export const hireDjangoPageData = {
  "helmet": {
    "title": "Hire Django Developers | Django Development Services",
    "description": "Hire skilled Django developers for secure, high-performing web solutions. Expert Django development services for all business sizes."
  },
  "hirePageBanner": {
    "diffBannerBackgroundImage": "url(/images/hire-page-images/hire-django.avif)",
    "image": "",
    "mainHeading": "Hire Django Developers",
    "content": "Looking to hire top-notch Django developers? At Bitsclan, we provide pre-vetted experts to build secure, scalable, & high-performing web applications tailored for startups & enterprises.",
    "btnText": "Consult our Django developers",
    "bannerList": [
      { "list": "Flexible Hiring Options" },
      { "list": "Full-time roles" },
      { "list": "Global teams" }
    ]
  },
  "hirePageExperties": {
    btnText: "Schedule a Call Today",
    "heading": "Our Django Developer Expertise",
    "discription": "At Bitsclan, our Django developers excel in building secure, scalable, & feature-rich web applications. Leveraging the power of Python & Django, we deliver seamless development that perfectly aligns with your business goals.",
    "servicesData": [
      {
        "title": "Django Consulting",
        "description": "Need expert guidance for your Django project? Our skilled Django developers provide strategic planning & technical advice to help you optimize your project & achieve maximum efficiency.",
        "icon": "/images/hire-page-icons/hire-django-icon1.svg"
      },
      {
        "title": "Django web Development",
        "description": "We specialize in building robust, feature-rich, & scalable web applications with Django. Whether you're launching a new project or upgrading an existing one, our developers ensure smooth performance & exceptional user experience.",
        "icon": "/images/hire-page-icons/hire-django-icon2.svg"
      },
      {
        "title": "Django API Development",
        "description": "Our Django experts build secure & efficient APIs that enable seamless communication between applications & services. From internal APIs to third-party integrations, we've got you covered.",
        "icon": "/images/hire-page-icons/hire-django-icon3.svg"
      },
      {
        "title": "Django CMS & Portal Development",
        "description": "Looking for a powerful CMS or web portal? Our Django developers build flexible, easy-to-manage solutions that are scalable & perfectly aligned with your business requirements.",
        "icon": "/images/hire-page-icons/hire-django-icon4.svg"
      },
      {
        "title": "Migration to Django",
        "description": "Planning to migrate your existing system to Django? Our experts handle the transition smoothly, ensuring minimal downtime & maximum performance.",
        "icon": "/images/hire-page-icons/hire-django-icon5.svg"
      },
      {
        "title": "Integration with Existing Solutions",
        "description": "Our Django developers specialize in integrating Django applications with other platforms, APIs, & third-party services, ensuring smooth functionality & enhanced performance.",
        "icon": "/images/hire-page-icons/hire-django-icon6.svg"
      },
      {
        "title": "Django eCommerce Solutions",
        "description": "We build high-performance eCommerce platforms with Django, offering secure payment gateways, seamless user experience, & scalable architecture to drive customer engagement.",
        "icon": "/images/hire-page-icons/hire-django-icon7.svg"
      },
      {
        "title": "Django Support & Maintenance",
        "description": "Ensure your Django application runs smoothly with our ongoing support & maintenance services. We handle regular updates, performance optimization, & bug fixes to keep your platform stable & secure.",
        "icon": "/images/hire-page-icons/hire-django-icon8.svg"
      }
    ]
  },
  "developmentPerformance": {
    btnText: "Hire a developer today",
    "heading": "Why Hire Django Developers ",
    "greenHeading": "from Bitsclan?",
    "subHeading": "At Bitsclan, we combine Django with the latest front-end & backend technologies to build secure, scalable, & high-performing applications tailored to your business needs.",
    "solutions": [
      {
        "icon": "/images/hire-page-icons/chose-ror-section1.svg",
        "title": "Access vetted talent",
        "description": "Meet skilled Django developers who are carefully vetted for their technical expertise & English fluency. You can be sure that you’re working with top-notch professionals."
      },
      {
        "icon": "/images/hire-page-icons/chose-ror-section2.svg",
        "title": "View matches in seconds",
        "description": "No more sifting through endless resumes. Find the perfect Django developers for hire quickly & easily through our platform with just a few clicks."
      },
      {
        "icon": "/images/hire-page-icons/chose-ror-section3.svg",
        "title": "Save with global hires",
        "description": "Tap into a talent pool of 450,000 professionals across 190 countries. With our global hiring options, you can save up to 58% compared to traditional hiring methods, without compromising on quality.",
        "noBorder": true
      },
      {
        "icon": "/images/hire-page-icons/chose-ror-section4.svg",
        "title": "Get real human support",
        "description": "Feel confident when you hire Django developers with our expert recruitment team's support. We're here to guide you every step of the way, ensuring you find the right talent for your project."
      }
    ]
  },
  "hireCombinationSection": {
    "combinations": [
      {
        "title": "Django + PostgreSQL + React",
        "description": "Django as a powerful backend framework, PostgreSQL for structured database management, & React for building dynamic front-end applications ensure a scalable & high-performance web solution.",
        "icons": [
          { "icon": "django.svg", "altText": "Django logo" },
          { "icon": "postgres.svg", "altText": "PostgreSQL logo" },
          { "icon": "react.svg", "altText": "React logo" }
        ]
      },
      {
        "title": "Django + GraphQL",
        "description": "GraphQL enables efficient data queries, Django provides a secure & scalable backend, & PostgreSQL ensures reliable data storage, making it an excellent choice for modern applications.",
        "icons": [
          { "icon": "django.svg", "altText": "Django logo" },
          { "icon": "graphql.svg", "altText": "GraphQL logo" },
          { "icon": "postgres.svg", "altText": "PostgreSQL logo" }
        ]
      },
      {
        "title": "Django + Redux Toolkit",
        "description": "Combining Django with Redux Toolkit enhances state management in front-end applications while maintaining a robust backend with Django & PostgreSQL.",
        "icons": [
          { "icon": "django.svg", "altText": "Django logo" },
          { "icon": "redux.svg", "altText": "Redux logo" },
          { "icon": "postgres.svg", "altText": "PostgreSQL logo" }
        ]
      },
      {
        "title": "Django + Next.js",
        "description": "Next.js enables server-side rendering (SSR) for better SEO & performance, paired with Django as the backend to create fast, scalable, & secure applications.",
        "icons": [
          { "icon": "django.svg", "altText": "Django logo" },
          { "icon": "next-js.svg", "altText": "Next.js logo" },
          { "icon": "postgres.svg", "altText": "PostgreSQL logo" }
        ]
      }
    ],
    "heading": "Top Django Technology Combinations for Robust Development",
    "description": "Leverage Django’s powerful framework with the best technology combinations to build secure, scalable, & high-performing applications. Hire expert Django developers to ensure seamless development & exceptional results."
  },
  "hirePageSteps": {
    btnText: "Let’s Find Your Perfect Developer",
    "heading": "Hire Django Developers in 4 Easy Steps",
    "subHeading": "Hiring top Django developers is now quick & hassle-free with our simple 4-step process. We ensure a smooth experience & the right talent for your project.",
    "steps": [
      {
        "title": "Choose your Engagement Model",
        "description": "Select the engagement model that works best for your project—whether it’s Full-Time, Part-Time, or Hourly. We offer flexible options to suit your needs.",
        "icon": "/images/hire-page-setps-icons/icon-1.svg"
      },
      {
        "title": "Screen & Select Django Developers",
        "description": "Browse through top Django developers for hire & choose the best candidates for your project. You can review their profiles & select the right ones to move forward.",
        "icon": "/images/hire-page-setps-icons/icon-2.svg"
      },
      {
        "title": "Conduct One-on-One Interview",
        "description": "Interview the shortlisted developers to assess their skills & expertise. Ask both theoretical & practical questions to ensure they’re the right fit for your team.",
        "icon": "/images/hire-page-setps-icons/icon-3.svg"
      },
      {
        "title": "Onboard Django Developers",
        "description": "Once you’ve made your selection, the final Django developer will join your team within 24-48 hours after confirmation, ready to start working on your project.",
        "icon": "/images/hire-page-setps-icons/icon-4.svg"
      }
    ]
  },
  "coverTheStack": {
    "whereStart": "Framework",
    "mainHeading": "Hire Expert Django Developers for Scalable & Secure Web Applications",
    "subHeading": "At Bitsclan, we empower your web development journey with a robust Django tech stack that ensures efficiency, security, & scalability. Our experienced Django developers leverage modern technologies to build high-performance, custom web applications tailored to your business needs.",
    "tabs": [
      "Framework",
      "Libraries",
      "Tools & Utilities",
      "Database",
      "Tools For PM"
    ],
    "tabItems": [
      { "tab": "Framework", "icon": "/images/django-tech.svg", "name": "Django" },
      { "tab": "Framework", "icon": "/images/tech-stack-icons/Pyramid.svg", "name": "Pyramid" },
      { "tab": "Framework", "icon": "/images/tech-stack-icons/Flask.svg", "name": "Flask" },
      { "tab": "Framework", "icon": "/images/tech-stack-icons/bottle.svg", "name": "Bottle" },
      { "tab": "Libraries", "icon": "/images/tech-stack-icons/fabric.svg", "name": "Fabric" },
      { "tab": "Libraries", "icon": "/images/tech-stack-icons/request.svg", "name": "Requests" },
      { "tab": "Libraries", "icon": "/images/tech-stack-icons/pillow.svg", "name": "Pillow/PIL" },
      { "tab": "Libraries", "icon": "/images/database6.png", "name": "wxPython" },
      { "tab": "Libraries", "icon": "/images/tech-stack-icons/scrapy.svg", "name": "Scrapy" },
      { "tab": "Tools & Utilities", "icon": "/images/tech-stack-icons/numpy.svg", "name": "NumPy" },
      { "tab": "Tools & Utilities", "icon": "/images/database1.png", "name": ".Net" },
      { "tab": "Tools & Utilities", "icon": "/images/database6.png", "name": "Python" },
      { "tab": "Tools & Utilities", "icon": "/images/tech-stack-icons/ruby_on_rails.svg", "name": "Ruby On Rails" },
      { "tab": "Tools & Utilities", "icon": "/images/tech-stack-icons/java.svg", "name": "Java" },
      { "tab": "Tools & Utilities", "icon": "/images/database8.png", "name": "PHP" },
      { "tab": "Tools & Utilities", "icon": "/images/django-tech.svg", "name": "Django" },
      { "tab": "Tools & Utilities", "icon": "/images/tech-stack-icons/golang.svg", "name": "Go" },
      { "tab": "Tools & Utilities", "icon": "/images/tech-stack-icons/c-sharp.svg", "name": "C#" },
      { "tab": "Tools & Utilities", "icon": "/images/tech-stack-icons/kotlin.svg", "name": "Kotlin" },
      { "tab": "Tools & Utilities", "icon": "/images/tech-stack-icons/scala.svg", "name": "Scala" },
      { "tab": "Tools & Utilities", "icon": "/images/tech-stack-icons/rust.svg", "name": "Rust" },
      { "tab": "Database", "icon": "/images/db5.png", "name": "MySQL" },
      { "tab": "Database", "icon": "/images/tech-stack-icons/oracals.svg", "name": "Oracle" },
      { "tab": "Database", "icon": "/images/db7.png", "name": "SQLite" },
      { "tab": "Database", "icon": "/images/db6.png", "name": "MS SQL" },
      { "tab": "Database", "icon": "/images/db3.png", "name": "MongoDB" },
      { "tab": "Database", "icon": "/images/tech-stack-icons/redis.svg", "name": "Redis" },
      { "tab": "Database", "icon": "/images/tech-stack-icons/postgres.svg", "name": "Postgres" },
      { "tab": "Tools For PM", "icon": "/images/tech-stack-icons/jira.svg", "name": "Jira" },
      { "tab": "Tools For PM", "icon": "/images/tech-stack-icons/trello.svg", "name": "Trello" },
      { "tab": "Tools For PM", "icon": "/images/tech-stack-icons/slack-icon.png", "name": "Slack" },
      { "tab": "Tools For PM", "icon": "/images/tech-stack-icons/zoom-icon.svg", "name": "Zoom" },
      { "tab": "Tools For PM", "icon": "/images/tech-stack-icons/google-meet.webp", "name": "Google Meet" }
    ]
  },
  "hireExpertFacts": {
    btnText: "book an appointment",
    "heading": "Quick Facts About ",
    "greenHeading": "Our Django Team",
    "facts": [
      {
        "text": "<strong>40+</strong> expert Django developers are ready to bring your project to life."
      },
      {
        "text": "Our developers have an average of <strong>6+ years</strong> of experience in Django development services."
      },
      { "text": "Proficiency in secure web development with Django, ensuring the safety of your application" },
      {
        "text": "Extensive experience in both front-end & back-end development."
      },
      { "text": "Skilled in building scalable, feature-rich web applications using Django." },
      { "text": "Well-versed in integrating Django with various platforms & services." }
    ],
    "diffBannerBackgroundImage": "url(/images/hire-page-images/hire-django.avif)"
  },
  "hirePageAppIdea": {
    heading: "Not sure about your app idea? Get your prototype up in 6-8 weeks!",
    "content": "Have an idea but unsure how to proceed? Our Django experts can help you build a working prototype in just 6-8 weeks! Validate your vision, test user engagement, & lay a solid foundation for success."
  },
  "hirePageEngagementModels": {
    btnText: "Get Started Now",
    "headingContent": [
      { "text": "Our Flexible" },
      { "text": "Engagement Models" }
    ],
    "discription": "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",
    "hiringDetails": [
      {
        "text": "Hourly Hiring",
        "hours": "24 - 48",
        "timeUnit": "hours",
        "icon": "time.svg",
        "bgColor": "#FDFDFF",
        "durationLabel": "Duration",
        "duration": "8 Hrs/Day",
        "minimumDaysLabel": "Minimum Days",
        "minimumDays": "30 Days",
        "billingLabel": "Billing",
        "billing": "Monthly",
        "startWorkPhrase": "Start work in "
      },
      {
        "text": "Full Time Hiring",
        "hours": "48",
        "timeUnit": "hours",
        "icon": "full-time.svg",
        "bgColor": "#FFFEFA",
        "durationLabel": "Duration",
        "duration": "8 Hrs/Day",
        "minimumDaysLabel": "Minimum Days",
        "minimumDays": "30 Days",
        "billingLabel": "Billing",
        "billing": "Monthly",
        "startWorkPhrase": "Get started within "
      },
      {
        "text": "Part Time Hiring",
        "hours": "24 - 48",
        "timeUnit": "hours",
        "icon": "part-time.svg",
        "bgColor": "#FDFFFA",
        "durationLabel": "Duration",
        "duration": "8 Hrs/Day",
        "minimumDaysLabel": "Minimum Days",
        "minimumDays": "30 Days",
        "billingLabel": "Billing",
        "billing": "Monthly",
        "startWorkPhrase": "Launch in "
      }
    ]
  },
  "secondFaq": {
    "specificClass": "mobile-dev-page",
    "faqs": [
      {
        "id": "collapseOne",
        "question": "How quickly can Django engineers start working on my project?",
        "answer": "At Bitsclan IT Solutions, Django engineers can join your project within 48–72 hours of agreement. We handle all onboarding tasks from repository access to environment setup so your team can start executing immediately without downtime."
      },
      {
        "id": "collapseTwo",
        "question": "What does your onboarding process look like?",
        "answer": "Our onboarding process ensures a smooth technical and operational handoff. We align on your sprint structure, tools (GitHub, Jira, Slack, Docker), and environments. Engineers are introduced to your team and workflows during a kickoff session, ensuring instant alignment on architecture and goals."
      },
      {
        "id": "collapseThree",
        "question": "Can I scale my Django team up or down during the project?",
        "answer": "Yes. You can scale your Django team in days, adding or releasing developers as your project evolves. Whether you need backend engineers, DevOps specialists, or QA support, we provide on-demand scalability without contract complexity."
      },
      {
        "id": "collapseFour",
        "question": "How do you maintain communication and collaboration across teams?",
        "answer": "Our engineers work in your time zone, joining daily standups, sprint reviews, and code syncs. We use tools like Slack, Zoom, and Jira to ensure transparent communication and real-time updates across distributed teams."
      },
      {
        "id": "collapseFive",
        "question": "How do you ensure developer quality and performance consistency?",
        "answer": "Every Django engineer at Bitsclan IT Solutions passes a multi-stage vetting process covering system architecture, REST API design, ORM optimization, and cloud deployment experience. We maintain consistency through peer reviews, code linting, and CI/CD pipelines."
      },
      {
        "id": "collapseSix",
        "question": "What if a Django developer isn’t a perfect fit for our project?",
        "answer": "If a developer doesn’t meet expectations, we’ll replace them immediately at no extra cost. Our focus is maintaining momentum, code quality, and delivery continuity throughout the engagement."
      },
      {
        "id": "collapseSeven",
        "question": "How do you manage offboarding or team transitions?",
        "answer": "Before offboarding, our engineers perform comprehensive handovers, including documentation, architecture diagrams, and environment credentials. All assets, code, and credentials remain fully under your ownership, ensuring no disruption or knowledge loss."
      },
      {
        "id": "collapseEight",
        "question": "How do you handle security and confidentiality?",
        "answer": "We sign strict NDAs and IP protection agreements before project kickoff. All work is conducted under secure repositories and encrypted communication channels, ensuring 100% data and code confidentiality."
      },
      {
        "id": "collapseNine",
        "question": "Can your Django engineers work alongside our existing in-house team?",
        "answer": "Absolutely. Our Django developers integrate directly into your team’s workflow, using your tools and adhering to your coding standards ensuring one unified delivery process across internal and external engineers."
      },
      {
        "id": "collapseTen",
        "question": "Do you provide post-engagement support after handover?",
        "answer": "Yes. We offer optional post-engagement support for a defined transition period, covering bug fixes, environment stabilization, and performance tuning ensuring a smooth continuation for your internal or next-phase team."
      }
    ],
    "mainHeading": "Frequently Asked Questions",
    "subHeading": "Explore our Django development services for tailored web solutions, API creation, & deployment management!"
  },
  "trendsInsights": {
    "specificClass": "mobile-dev-page",
    "category": "all"
  },
  "contactSection": {},
  "footer": {}
};

export const hireDjangoEngagementModeContent = {
  shortHeading: "Our Engagement Models",
  heading: "Engagement Packages",
  subheading: "Selecting the right engagement model is key. We provide flexible options, from dedicated Django development teams to project based collaborations, ensuring seamless integration, transparent communication, and maximum efficiency to accelerate your web application or backend project goals.",
  models: [
    {
      icon: "/images/engagement-model-gifs/hourly-icon.svg",
      index: 1,
      iconWidth: 40,
      title: "Flexible Model",
      description: "Perfect for teams that need immediate backend capacity or specialized Django support. Plug our Django engineers into your workflow to handle API development, data pipelines, and quick iterations while maintaining full visibility and control.",
    },
    {
      icon: "/images/engagement-model-gifs/price-icon.svg",
      index: 2,
      iconWidth: 35,
      title: "Dedicated Team",
      description: "A long-term Django team with backend developers, data engineers, and QA professionals managing your full app lifecycle from design and development to scaling and optimization. Designed for enterprises needing secure, high-availability platforms built for growth.",
    }
  ],
  cta: {
    text: "Accelerate Your Projects with Expert Django Development Talent.",
    button: "Hire Your Django Developer Today",
    link: "/contact-us"
  }
}
